import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../shared/table/Table';
import ErrorMessage from '../../shared/message/ErrorMessage';

const columns = [
  {
    id: 'id',
    title: 'ID',
  },
  {
    id: 'group_id',
    title: 'Access group',
    type: 'select',
  },
  {
    id: 'name',
    title: 'Name',
  },
  {
    id: 'key',
    title: 'Key',
    copy: true,
  },
];

class ApiPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.generateKey = this.generateKey.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.loadGroupPermissions = this.loadGroupPermissions.bind(this);
    this.loadKeys = this.loadKeys.bind(this);
    this.onSelectPageSize = this.onSelectPageSize.bind(this);
    this.onSelectPage = this.onSelectPage.bind(this);
    this.onRowSave = this.onRowSave.bind(this);
  }

  componentDidMount() {
    this.loadKeys(this.props.team, this.props.page, this.props.pageSize);
  }

  componentDidUpdate(prevProps, prevState) {
    const isDifferentTeam = this.props.team && (!prevProps.team || prevProps.team.id !== this.props.team.id);
    if (isDifferentTeam) {
      this.loadKeys(this.props.team, this.props.page, this.props.pageSize);
    }
  }

  componentWillUnmount() {
    this.props.set({ dataReturned: false });
  }

  loadKeys(team, page, pageSize) {
    this.props.getTeamKeys(team, page, pageSize);
  }

  generateKey() {
    this.props.setTeamKey(this.props.team, this.props.groupId, this.props.name, this.props.page, this.props.pageSize);
  }

  onSearchInputChange(event) {
    this.props.set({
      name: event.target.value,
    });
  }

  handleChange(value) {
    this.props.set({ selectValue: value });
  }

  loadGroupPermissions(group) {
    this.props.set({
      groupId: group.target.value,
    });
  }

  onSelectPageSize(pageSize) {
    this.loadKeys(this.props.team, this.props.page, pageSize);
  }

  onSelectPage(page) {
    this.loadKeys(this.props.team, page, this.props.pageSize);
  }

  onRowSave(index, row) {
    this.props.updateKey(this.props.team, row, this.props.page, this.props.pageSize);
  }

  render() {
    let groups = this.props.groups;
    const groupRenderer = (group) => <span>{group.name}</span>;
    const hasPermission = this.props.checkPlanPermission('api_access') || false;
    const keys = this.props.keys;

    const bulkActions = [
      {
        text: 'Delete selected',
        hasPermission,
        className: ' danger',
        onClick: (keys) => {
          this.props.deleteKeys(this.props.team, keys, this.props.page, this.props.pageSize);
        },
      },
      {
        text: 'New API key:',
        className: 'divider',
        type: 'input',
        placeholder: 'API name',
        value: this.props.name,
        onChange: (e) => {
          this.onSearchInputChange(e);
        },
      },
      {
        text: '',
        type: 'select',
        labelKey: 'name',
        valueKey: 'id',
        options: groups || [],
        value: this.props.groupId,
        hasPermission,
        onChange: (e) => {
          this.loadGroupPermissions(e);
        },
      },
      {
        text: 'Generate API key',
        bypassCheck: true,
        hasPermission,
        onClick: (e) => {
          this.generateKey(e);
        },
      },
    ];

    let editableColumns;

    if (groups) {
      editableColumns = {
        group_id: {
          validValues: groups,
        },
        name: {},
      };
    }

    return (
      <div className="api-page">
        <form>
          <div className="title-container">
            <h2> API </h2>
          </div>

          <p>
            {' '}
            You’ll need an API key if you want to programmatically create and modify charts hosted in the service.{' '}
            <a href="https://www.highcharts.com/blog/tutorials/use-highcharts-cloud-api/" target="_blank">
              {' '}
              Read more.{' '}
            </a>{' '}
          </p>

          <div className="clearfix" />
          <div className="main-content-container">
            <div className="alert alert-warning">
              Your team id is: <strong>{this.props.team.id}</strong>
              {this.props.division && this.props.division.id !== null && (
                <span>
                  , Your Division ID is: <strong>{this.props.division.id} </strong>
                </span>
              )}
            </div>
            <ErrorMessage error={this.props.error} />
            <Table
              columns={columns}
              bulkActions={bulkActions}
              rows={keys}
              onRowSave={this.onRowSave}
              editableColumns={editableColumns}
              searchPlaceholder="Search for keys"
              onSelectPageSize={this.onSelectPageSize}
              onSelectPage={this.onSelectPage}
              page={this.props.page}
              pageCount={this.props.pageCount}
              pageSize={this.props.pageSize}
              dataReturned={this.props.dataReturned}
              pagePosition="bottom"
              className={'page-bottom'}
            />
          </div>
        </form>
      </div>
    );
  }
}

ApiPage.propTypes = {
  team: PropTypes.object.isRequired,
  paths: PropTypes.object.isRequired,
  checkPermission: PropTypes.func,
  groups: PropTypes.array,
  loadGroups: PropTypes.func,
  division: PropTypes.object,
};

export default ApiPage;
